import { F0Box, F0Text } from '@factorialco/f0-react'

import type { SalaryByWorkplaceGroup } from 'modules/job_catalog/lib/salaryUtils'

interface SalariesCardProps {
  groupedSalaries: SalaryByWorkplaceGroup[]
}

const SalariesCard = ({ groupedSalaries }: SalariesCardProps) => {
  const removeTrailingZeroDecimals = (value: string) => {
    return value.replace(/([.,]00)(?=(\s|$|-|–))/g, '')
  }

  return (
    <F0Box border="default" borderColor="secondary" borderRadius="md" overflow="hidden">
      {groupedSalaries.map(({ groupKey, workplaceLabel, formattedRange }, index) => {
        return (
          <F0Box
            key={groupKey}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="between"
            padding="md"
            borderBottom={index === groupedSalaries.length - 1 ? undefined : 'default'}
            borderColor={index === groupedSalaries.length - 1 ? undefined : 'secondary'}
          >
            <F0Text content={workplaceLabel} variant="description" />
            <F0Text content={removeTrailingZeroDecimals(formattedRange)} variant="label" />
          </F0Box>
        )
      })}
    </F0Box>
  )
}

export default SalariesCard
